import { Skeleton } from '@nexelem/components';
import { GRID_CHECKBOX_SELECTION_FIELD } from '@mui/x-data-grid-pro';
import type { GridColDef, GridRenderCellParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import type { CustomGridColDef } from '../services';

export const createSkeletonRenderer =
  <T extends GridValidRowModel>(column: GridColDef<T> | CustomGridColDef<T>): GridColDef<T>['renderCell'] =>
  // eslint-disable-next-line react/display-name
  (params: GridRenderCellParams<T>) => {
    if (params.row._isSkeleton) {
      const align = column.align || 'left';
      const hasHeaderName = column.headerName || column.renderHeader;
      const customStatus = column.field === 'status-custom';
      const isCheckboxColumn = column.field === GRID_CHECKBOX_SELECTION_FIELD;

      return (
        <div className="flex h-full items-center" style={{ justifyContent: align }}>
          {customStatus && (
            <div className="box-border aspect-square max-h-6 w-6">
              <Skeleton className="h-full rounded-full" />
            </div>
          )}
          {isCheckboxColumn && <Skeleton className="ml-2 size-4.5" />}
          {hasHeaderName && !isCheckboxColumn && <Skeleton className="h-6 w-4/5" />}
        </div>
      );
    }

    return (column as GridColDef).renderCell?.(params) ?? params.formattedValue ?? params.value;
  };
